import React from 'react';
import BillingGroupTable from './tables/BillingGroupTable';
import UsersTable from './tables/UsersTable';
import ContactsTable from './tables/ContactsTable';
// import InvoiceTable from './tables/InvoicesTable';
import ZendeskTable from './tables/ZendeskTable';
import BedriftsnettTable from './tables/BedriftsnettTable';
import VismaInvoiceTable from './tables/VismaInvliceTable';

interface CustomerTabsProps {
	activeTab: string;
	customerId: string;
	userTableFilter: boolean;
	setUserTableFilter: (value: boolean) => void;
}

const CustomerTabs: React.FC<CustomerTabsProps> = ({
	activeTab,
	customerId,
	userTableFilter,
	setUserTableFilter,
}) => {
	return (
		<>
			{activeTab === '1' && <UsersTable
				id={customerId}
				userTableFilter={userTableFilter}
				setUserTableFilter={setUserTableFilter}
			/>}
			{activeTab === '2' && <BillingGroupTable id={customerId} />}
			{activeTab === '3' && <ContactsTable id={customerId} />}
			{activeTab === '4' && <VismaInvoiceTable id={customerId} />}
			{activeTab === '5' && <ZendeskTable id={customerId} />}
			{activeTab === '6' && <BedriftsnettTable id={customerId} />}
		</>
	);
}

export default CustomerTabs;
